<template lang="pug">
#article
  spinner(v-if="settings.loading")
  .article-wrapper(
    v-else
    :class="`is-${theme}`"
  )
    .article-editor
      .article-actions
        b-field(grouped)
          b-field(expanded style="max-width: calc(100% - 190px);")
            article-title-field(
              :value="article.title"
              @input="saveTitle"
            )
          p.control
            a.button(
              href="http://assemble.io/docs/Cheatsheet-Markdown.html"
              target="_blank"
              :class="buttonClass"
            )
              b-icon(icon="information-outline")
          p.control
            a.button(
              :class="buttonClass"
              @click="theme = (theme === 'light' ? 'dark' : 'light')"
            )
              b-icon(
                :icon="theme === 'light' ? 'lightbulb-on-outline' : 'lightbulb-outline'"
              )
          p.control
            a.button.is-success(
              :disabled="noChanges"
              @click="publish"
            ) Publish
      b-input.article-body(
        type="textarea"
        :value="article.draft_body"
        @input="set($event, 'draft_body')"
      )
    .article-preview
      .content
        .has-text-centered
          h1 {{ article.title }}
        span(v-html="compiledMarkdown")
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import marked from 'marked';
import ArticleForm from '@/components/form/article/ArticleForm';
import ArticleTitleField from '@/components/form/article/ArticleTitleField';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'article-editor',
  components: {
    ArticleTitleField,
    Spinner,
  },
  computed: {
    ...mapGetters({
      article: getters.GET_ARTICLE,
    }),
    buttonClass() {
      return this.theme === 'dark' ? 'is-dark' : 'is-light';
    },
    compiledMarkdown() {
      if (!this.article.draft_body) return '';
      return marked(this.article.draft_body);
    },
    noChanges() {
      return this.article.body === this.article.draft_body;
    },
  },
  async created() {
    this.settings.loading = true;
    await this.$store.dispatch(actions.DO_GET_ARTICLE, {
      id: this.id,
      zoom: 'artwork,author,tags',
    });
    if (this.article.draft_body) {
      this.body = this.article.draft_body.replace(/\n{2,}/g, '<br><br>').replace(/\n/g, '<br>');
    }
    setTimeout(() => {
      this.settings.loading = false;
    }, 250);
  },
  data() {
    return {
      body: null,
      settings: {
        loading: false,
      },
      theme: 'light',
    };
  },
  methods: {
    publish() {
      this.$store.commit(mutations.SET_ARTICLE_EDITING, _.cloneDeep(this.article));
      this.$buefy.modal.open({
        parent: this,
        component: ArticleForm,
        hasModalCard: true,
      });
    },
    async saveDraft() {
      await this.$store.dispatch(actions.DO_UPDATE_ARTICLE, {
        id: this.article.id,
        ignore: true,
        draft_body: this.article.draft_body,
        title: this.article.title,
        zoom: 'author',
      });
    },
    saveTitle(val) {
      this.$store.commit(mutations.SET_ARTICLE_FIELD, {
        key: 'title',
        val,
      });
      this.saveDraft();
    },
    set(val, key) {
      this.$store.commit(mutations.SET_ARTICLE_FIELD, {
        key,
        val,
      });
      this.saveDraft();
    },
  },
  props: {
    id: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
$actions-height: 90px;
#article {
  .article-wrapper {
    height: 100vh;
    display: flex;
    //transition: 0.35s background-color ease-in-out;
    &.is-light {
      background-color: $white;
      color: $grey-darker;
      .article-actions {
        background-image: linear-gradient(white 40%, transparent);
      }
      .article-editor {
        border-color: $grey-lighter;
      }
    }
    &.is-dark {
      background-color: rgb(33, 37, 43);
      .article-actions {
        background-image: linear-gradient(#21252b 40%, transparent);
        .button.is-dark {
          background-color: #2c323a !important;
        }
      }
      .article-body, .content {
        color: $grey-lighter !important;
        h1, h2, h3, h4, h5, h6, strong, b, textarea {
          color: $grey-lighter !important;
        }
      }
      .article-editor {
        border-color: #2c323a;
      }
    }
    & > div {
      height: 100%;
      width: 50%;
      .content {
        height: 100%;
        padding: 5rem 5rem 12rem 5rem;
        overflow-y: scroll;
        //transition: 0.35s color ease-in-out;
        &:focus {
          outline: none;
        }
        h1, h2, h3, h4, h5, h6, strong, b {
          //transition: 0.35s color ease-in-out;
        }
      }
    }
    .article-editor {
      border-right: 1px solid;
      //transition: 0.35s border-color ease-in-out;
      .article-actions {
        position: fixed;
        z-index: 1;
        padding: 1rem;
        width: calc(50% - #{1 * 3}rem);
        .field {
          justify-content: flex-end;
        }
      }
      .article-body {
        overflow-y: hidden;
        height: 100vh;
        textarea {
          border: none;
          font-family: 'Roboto Mono', monospace;
          font-size: 1.15rem;
          line-height: 175%;
          height: 100%;
          max-height: none;
          padding: 6rem 1.5rem;
          background-color: transparent;
          &:focus {
            border: none;
          }
        }
      }
    }
    .article-preview {
      font-family: 'EB Garamond', serif;
      font-size: 1.35rem;
      line-height: 175%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Article.vue